import React from "react";
import styled from "styled-components";
import { Col } from "common/components";
import Description from "security-app/components/Investigations/Details/ProceduresSegment/Procedures/description";
import Steps from "./Steps";
const StyledCol = styled(Col)`
  padding: ${({ theme }) => theme.spacings.md};
`;
function useTableElements() {
  const renderExpanded = (procedure) => /* @__PURE__ */ React.createElement(StyledCol, null, /* @__PURE__ */ React.createElement(Description, { title: "Procedure Description:", description: procedure.description, isOpen: true }), /* @__PURE__ */ React.createElement("strong", null, "Procedure Steps:"), /* @__PURE__ */ React.createElement(Steps, { procedure }));
  const expandedSections = {
    restFieldsExpandedSection: {
      title: null,
      content: renderExpanded,
      disableHeader: true
    }
  };
  return {
    expandedSections
  };
}
export default useTableElements;
